import { Injectable } from '@angular/core';
import { Observable, Observer, Subject, takeUntil } from 'rxjs';
import { global } from '../global';
import { CookieService } from 'ngx-cookie-service';
import * as pako from 'pako';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import axios from 'axios';
import { conSesionEnUrl } from '../shared/utils/session-url.util';

@Injectable({
    providedIn: 'root',
})

export class SseService {
  
    public url : string;
    public urlgw : string = global.session.gwBaseUrl;
    public licencia:string = this.cookieService.get('auth_token');
    public isLogin: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public valIsLogin$ = this.isLogin.asObservable();
    private event : EventSource | null;
    private controller: AbortController | null = null;
    private eventSource: EventSource | null = null;
    private abortController: AbortController | null = null;
    private eventSources: Array<EventSource | null> = [null, null, null];

    constructor (private cookieService: CookieService,
        private http: HttpClient
        ){
        this.url=global.url;
    }

    apiGetSse2(endpoint: string, conexion: number = 0): Observable<any> {
        return new Observable(observer => {
            // Cierra la conexión previa en ese slot si existe
            if (this.eventSources[conexion]) {
                this.eventSources[conexion]!.close();
                this.eventSources[conexion] = null;
            }
            this.eventSources[conexion] = new EventSource(conSesionEnUrl(`${global.url}${endpoint}`, this.cookieService.get('session_id')));

            const eventNames = [
                'resultados','result','batchProgress', 'omitido', 'msg', 'ope', 'mod', 'nom', 'vla', 'vli', 'pos', 'ven', 'ren', 'rie', 'rea', 'companias', 'lva', 'lvn', 'total', 'err', 'ico', 'progreso', 'licencia', 'done', 'fin'
            ];

            eventNames.forEach(eventName => {
                this.eventSources[conexion]!.addEventListener(eventName, (evento: MessageEvent) => {
                    let data = evento.data;
                    try {
                        data = JSON.parse(data);
                    } catch {}
                    observer.next({ name: eventName, data });
                });
            });

            this.eventSources[conexion]!.onmessage = (event) => {
                let data = event.data;
                try {
                    data = JSON.parse(data);
                } catch {}
                observer.next({ name: 'message', data });
            };

            this.eventSources[conexion]!.onerror = (error) => {
                console.log('SSE Error - cerrando conexión', conexion);
                this.eventSources[conexion]?.close();
                this.eventSources[conexion] = null;
                // Completar en lugar de emitir error para evitar efectos secundarios
                observer.complete();
            };

            // Limpieza al cancelar la subscripción
            return () => {
                if (this.eventSources[conexion]) {
                    this.eventSources[conexion]!.close();
                    this.eventSources[conexion] = null;
                }
            };
        });
    }

    apiGetSse(endpoint: any, token: boolean, data:any): Observable<any>{
        const params=new URLSearchParams(data).toString();
        let url: string = `${this.url}${endpoint}${params}`;
        //const fullUrl = this.url + endpoint + (params ? `?${params}` : '');
        let ope:any;
        let vla:any;
        let vli:any;
        let pos:any;
        this.controller = new AbortController();

        // Instancia local (no this.event): con dos apiGetSse concurrentes, sobreescribir un unico
        // campo compartido hacia que el onerror/disconnect de una llamada cerrara la EventSource de
        // OTRA llamada distinta todavia en curso (Broken pipe en el backend, Observable que nunca
        // completa en el cliente). this.event se sigue actualizando para no romper el uso externo de
        // disconnect() (p.ej. strategy-factory.component.ts), pero cada llamada solo cierra la suya.
        const event = new EventSource(conSesionEnUrl(url, this.cookieService.get('session_id')));
        this.event = event;
        const eventSubject = new Subject<any>();
        event.addEventListener('ope', (evento: MessageEvent)=>{
            ope = this.descomprimirDatos(evento.data);
            ope = JSON.parse(ope);
            //descomp = JSON.parse(evento.data);
            const evenDataWithName = { name: 'ope', data:ope };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('mod', (evento: MessageEvent)=>{
            const evenData = JSON.parse(evento.data);
            const evenDataWithName = { name: 'mod', data:evenData };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('analysisSummary', (evento: MessageEvent)=>{
            const evenData = JSON.parse(evento.data);   
            const evenDataWithName = { name: 'analysisSummary', data:evenData };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('nom', (evento: MessageEvent)=>{
           // const evenData = JSON.parse(evento.data);
            const evenDataWithName = { name: 'nom', data:evento.data };
            eventSubject.next(evenDataWithName);
        });
        //licencia
        event.addEventListener('licencia', (evento: MessageEvent)=>{
            const evenDataWithName = { name: 'licencia', data:evento.data };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('vla', (evento: MessageEvent)=>{
            vla = this.descomprimirDatos(evento.data);
            vla = JSON.parse(vla);
           // const evenData = JSON.parse(evento.data);
            const evenDataWithName = { name: 'vla', data:vla };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('vli', (evento: MessageEvent)=>{
            vli = this.descomprimirDatos(evento.data);
            vli = JSON.parse(vli);
            //const evenData = JSON.parse(evento.data);
            const evenDataWithName = { name: 'vli', data:vli };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('pos', (evento: MessageEvent)=>{   
            pos = this.descomprimirDatos(evento.data);
            pos = JSON.parse(pos);
            //const evenData = JSON.parse(evento.data);
            const evenDataWithName = { name: 'pos', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('ven', (evento: MessageEvent)=>{   
            pos = this.descomprimirDatos(evento.data);
            pos = JSON.parse(pos);
            //const evenData = JSON.parse(evento.data);
            const evenDataWithName = { name: 'ven', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('ren', (evento: MessageEvent)=>{   
            pos = this.descomprimirDatos(evento.data);
            pos = JSON.parse(pos);
            const evenDataWithName = { name: 'ren', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('rie', (evento: MessageEvent)=>{   
            pos = this.descomprimirDatos(evento.data);
            pos = JSON.parse(pos);
            const evenDataWithName = { name: 'rie', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('rea', (evento: MessageEvent)=>{   
            pos = this.descomprimirDatos(evento.data);
            pos = JSON.parse(pos);
            const evenDataWithName = { name: 'rea', data:pos };
            eventSubject.next(evenDataWithName);
        });//rastreador
        event.addEventListener('companias', (evento: MessageEvent)=>{   
            pos = evento.data;
            pos = JSON.parse(pos);
            const evenDataWithName = { name: 'companias', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('lva', (evento: MessageEvent)=>{   
//            pos = this.descomprimirDatos(evento.data);
            pos = evento.data;
            pos = JSON.parse(pos);
            const evenDataWithName = { name: 'lva', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('lvn', (evento: MessageEvent)=>{   
//            pos = this.descomprimirDatos(evento.data);
              pos = evento.data;
          pos = JSON.parse(pos);
            const evenDataWithName = { name: 'lvn', data:pos };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('arrayResultados', (evento: MessageEvent)=>{
            const evenDataWithName = { name: 'arrayResultados', data: evento.data };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('idAnalisis', (evento: MessageEvent)=>{
            const evenDataWithName = { name: 'idAnalisis', data: evento.data };
            eventSubject.next(evenDataWithName);
        });
        event.addEventListener('total', (evento: MessageEvent)=>{   
            pos = evento.data;
            pos = JSON.parse(pos);
            const evenDataWithName = { name: 'total', data:pos };
            eventSubject.next(evenDataWithName);
        });//total
        event.addEventListener('err', (evento: MessageEvent)=>{   
            const evenDataWithName = { name: 'err', data: evento.data };
            eventSubject.next(evenDataWithName); 
//            console.log("MANEJO DE EVENTOS DE ERROR: ",evento.data )
        });
        // El backend aborta el modelo cuando una condición no se puede evaluar (indicador o DSL no
        // soportado). Sin este listener el evento se perdía y el modelo acababa vacío sin aviso.
        event.addEventListener('modelUnsupported', (evento: MessageEvent)=>{
            let data: any = evento.data;
            try { data = JSON.parse(data); } catch { /* texto plano */ }
            eventSubject.next({ name: 'modelUnsupported', data });
        });
        event.addEventListener('info', (evento: MessageEvent)=>{
            const evenDataWithName = { name: 'info', data: evento.data };
            eventSubject.next(evenDataWithName);
//            console.log("MANEJO DE EVENTOS DE INFO: ",evento.data )
        });
        event.addEventListener('ico', (evento: MessageEvent)=>{   
            const evenDataWithName = { name: 'ico', data: evento.data };
            eventSubject.next(evenDataWithName); 
//            console.log("MANEJO DE EVENTOS DE ERROR: ",evento.data )
        });
        event.addEventListener('result', (evento: MessageEvent)=>{   
            const evenDataWithName = { name: 'result', data: evento.data };
            eventSubject.next(evenDataWithName);
            //console.log("MANEJO DE EVENTOS DE ERROR: ",evento.data )
        });
        event.addEventListener('omitido', (evento: MessageEvent)=>{   
            const evenDataWithName = { name: 'omitido', data: evento.data };
            eventSubject.next(evenDataWithName);
            //console.log("MANEJO DE EVENTOS DE ERROR: ",evento.data )
        });
        event.addEventListener('msg', (evento: MessageEvent)=>{
            const evenDataWithName = { name: 'msg', data: evento.data };
            eventSubject.next(evenDataWithName);
            //console.log("MANEJO DE EVENTOS DE ERROR: ",evento.data )
        });
        event.addEventListener('fin', (evento: MessageEvent)=>{
            const evenDataWithName = { name: 'fin', data: evento.data };
            eventSubject.next(evenDataWithName);
            //console.log("MANEJO DE EVENTOS DE ERROR: ",evento.data )
        });
        //err

        event.onerror = (errorEvent: Event) =>{
            //console.log('Error: ', errorEvent);
            eventSubject.complete();
            event.close();
            // Solo limpiar this.event/this.controller si nadie mas los reemplazo entretanto -- si
            // otra llamada a apiGetSse ya arranco, son suyos, no de esta.
            if (this.event === event) {
                this.event = null;
                if (this.controller) {
                    this.controller = null;
                }
            }
        }
        return eventSubject.asObservable().pipe(
            takeUntil(new Observable((observer) => eventSubject.subscribe({
              complete: () => observer.next()
            })))
          );

    }

    apiPostNew(endpoint: any, data: any={}, auth_token: any)/* : Observable<any> */{
        let url: string = `${this.url}${endpoint}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'licencia':  auth_token
          });
      
          return this.http.post<any>(url, data, { headers });
    }

    apiPutNew(endpoint: any, data: any={}, auth_token: any)/* : Observable<any> */{
        let url: string = `${this.url}${endpoint}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'licencia':  auth_token
          });
          return this.http.put<any>(url, data, { headers });
    }


    apiPostNewSinToken(endpoint: any, data: any={})/* : Observable<any> */{
        let url: string = `${this.url}${endpoint}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'licencia':  'XXXXX'
          });
      
          return this.http.post<any>(url, data, { headers });
    }
    apiPostNewGW(endpoint: any, data: any={})/* : Observable<any> */{
        let url: string = `${this.urlgw}${endpoint}`;     
        return this.http.post<any>(url, data);
    }

    apiDelete(endpoint: any, auth_token: any)/* : Observable<any> */{
        let url: string = `${this.url}${endpoint}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'licencia':  auth_token
          });     
          return this.http.delete<any>(url, { headers });
    }

    apiDeleteGW(endpoint: any)/* : Observable<any> */{
        let url: string = `${this.urlgw}${endpoint}`;
          return this.http.delete<any>(url);
    }

    apiPost(endpoint: string, token: boolean, data: any, url: number) {
        let licencia = this.cookieService.get('auth_token');
        var peticion = `${this.url}${endpoint}${url === 1 ? '.php' : ''
            }`;
        var mheaders = {
            'Content-Type': 'application/json',
            licencia: licencia,
        };

        if (!!token) {
            const authToken = this.cookieService.get('auth_token'); // Obtén el token de las cookies
            if (authToken) {
                mheaders.licencia = authToken; // Asigna el token a tus encabezados
            }
        }

        return axios.post(peticion, JSON.stringify(data), {
            headers: mheaders,
        });
    }

    apiGetNew(endpoint: any): Observable<any>{
        let url: string = `${this.url}${endpoint}`;    
        return this.http.get<any>(url);
    }
    apiGetWithAuth(endpoint: any, auth_token: any): Observable<any>{
        let url: string = `${this.url}${endpoint}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'licencia': auth_token
        });
        return this.http.get<any>(url, { headers });
    }
    apiGetNewGW(endpoint: any): Observable<any>{
        let url: string = `${this.urlgw}${endpoint}`;    
        return this.http.get<any>(url);
    }
    descomprimirDatos(datosBase64: string): string {
        // Decodifica los datos Base64
        const datosDecodificados = atob(datosBase64);
        
        // Convierte los datos decodificados en un ArrayBuffer
        const arrayBuffer = new ArrayBuffer(datosDecodificados.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < datosDecodificados.length; i++) {
          uint8Array[i] = datosDecodificados.charCodeAt(i);
        }
        
        // Descomprime los datos usando pako
        const datosDescomprimidos = pako.inflate(uint8Array, { to: 'string' });
    
        return datosDescomprimidos;
      }
      
      updateLogin(data: boolean){
        this.isLogin.next(data);
      }

    disconnect(){
        if(this.event){
            //console.log("cerrando evento");
            this.event.close();
            this.event = null;
        }
    }
    abortRequests() {
        if (this.controller) {
          this.controller.abort();
          this.controller = null;
        }
      }

    abortConnection(endpoint: string) {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
    }

    disconnectAll() {
        this.eventSources.forEach((es, idx) => {
            if (es) {
                es.close();
                this.eventSources[idx] = null;
            }
        });
    }
    apiDeleteWithBody(endpoint: string, data: any) {

        const licencia = this.cookieService.get('auth_token');

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'licencia': licencia
        });

        return this.http.delete<any>(
            `${this.url}${endpoint}`,
            {
                headers,
                body: data
            }
        );
    }
}